import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Button, Input } from "antd";
import { swalNotification } from "../../../alret/notificztion";
import { validationErrors } from "../../../../utils/Helpers";
import { getZoneList } from "../../../../services/zone.service";
const { Option } = Select;
const ModalAssignRiderZones = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneDefaultValue, setPostDataZoneDefaultValue] =
    useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);

  useEffect(() => {
    if (props.visible) {
      postLists();
    }
  }, [props.visible]);
  const postLists = async () => {
    try {
      setMBtnLoading(true);
      const resp = await getZoneList();
      setPostDataZoneDefaultValue(resp.data.data[0].id);
      setPostDataZone(filterPostDataZone(resp.data.data));
      // console.log("Zone list DV", resp.data.data[0].id);
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
    }
  };
  const filterPostDataZone = (values) => {
    const zoneData = [];
    values.map((item) => {
      zoneData.push(<Option value={item.id}>{item.zoneName}</Option>);
    });
    return zoneData;
  };

  const handleOkOrder = async (values) => {
    try {
      setMBtnLoading(true);
      swalNotification(
        "Rider Zone",
        "Rider Zone Assign successfully",
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {
    props.setvisible(false);
  };

  return (
    <Modal
      title="Zone visible"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button form="modalForm" loading={MBtnLoading} htmlType="submit">
          Save
        </Button>,
      ]}
    >
      <Form id="modalForm" layout="vertical" onFinish={handleOkOrder}>
        <Form.Item
          name={"zones"}
          label="Select Zone"
          rules={[{ required: true, message: "Zone is Required" }]}
        >
          <Select
            disabled={MBtnLoading}
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            // defaultValue={[postDataZoneDefaultValue]}
            // defaultValue={["6356896119796d3a37d8f51e"]}
            placeholder="Please select Zone"
            style={{
              minWidth: "100%",
            }}
          >
            {postDataZone}
          </Select>
        </Form.Item>
        <Form.Item
          name={"rider"}
          label="Rider"
          rules={[{ required: true, message: "Rider is Required" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAssignRiderZones;
